import blog1 from "../../assets/images/blog/sunderedLogo.jpg";
import blog2 from "../../assets/images/blog/givaudanCarto.jpg";
import blog3 from "../../assets/images/blog/hrc-entree.jpg";

const BlogContent = [
  {
    images: blog1,
    title: "Gameplay programming on Sundered with Thunder Lotus, including boss mechanics, Unity/C# work, PS4 optimization, and Sony TRC validation.",
    href: "https://www.gog.com/en/game/sundered",
    category: "Thunder Lotus · Sundered",
  },
  {
    images: blog2,
    title: "Lead development on perfumer workflows and olfactive data visualization, including React refactors, Node.js features, and D3.js relationship maps.",
    href: "https://www.givaudan.com/fragrance-beauty/perfumery-school/carto-the-future-of-fragrance-formulations",
    category: "Olympe.io · Givaudan",
  },

  {
    images: blog3,
    title: "React and TypeScript redesign of a hospital directory app, improving navigation speed and making key information easier to reach.",
    href: "https://www.hopitalrivierachablais.ch/",
    category: "HRC Directory App",
  },
];

export default BlogContent;
